@let type = componentType();
@if (type) {
    <ng-container *ngComponentOutlet="
  type;
  inputs: inputs();
  " />
} @else {
    unknown component: {{blok().component}}
}
